// src/components/ImagePromptModal.jsx
import React, { useState } from 'react';
import './ImagePromptModal.css';

const ImagePromptModal = ({ onSubmit, onCancel }) => {
  const [prompt, setPrompt] = useState('');

  const handleSubmit = () => {
    if (prompt.trim()) {
      onSubmit(prompt.trim());
    }
  };

  return (
    <div className="image-prompt-modal">
      <h2>Generate Image</h2>
      <textarea
        value={prompt}
        onChange={(e) => setPrompt(e.target.value)}
        placeholder="Describe the image you want to generate..."
        rows="4"
      />
      <div className="modal-buttons">
        <button onClick={handleSubmit}>Generate</button>
        <button onClick={onCancel}>Cancel</button>
      </div>
    </div>
  );
};

export default ImagePromptModal;